import doc                    from '@widesk-core/decorators/doc';
import AbstractExhibitorModel from './AbstractExhibitorModel';
import EntityModel            from '@models/fondations/EntityModel';

@doc.urnResource('exhibitor')
export default class ExhibitorModel extends AbstractExhibitorModel {
	@doc.modelUrn(EntityModel) declare entity: EntityModel;
}
